<div class="campanha-filter">
    <div class="campanha-filter-quick">  
        <div class="campanha-filter-quick-block campanha-filter-quick-block-options">
            <div class="campanha-filter-quick-block-data">
                <!-- Data de Vigência -->
                <div class="input-group">
                    <sgt-datepicker 
                       [(ngModel)]="filter.dataInicioVigencia" 
                       [(startDate)]="filter.dataInicioVigenciaPeriodo"
                       [(endDate)]="filter.dataTerminoVigenciaPeriodo"
                       name="dataVigenciaFilter" 
                       id="dataVigenciaFilter"
                       #dataVigenciaFilter="ngModel" #dataVigenciaDatepicker [ngControl]="dataVigenciaFilter" 
                       [mode]="dataVigenciaDatepickerMode"
                       [showBtnCalendar]="false"
                       inputPrependText="Vigência"
                       [withNavigation]="true"
                       [showPeriodicidadeDiaria]="true"
                       [showPeriodicidadeMensal]="true"
                       [showPeriodicidadeTrimestral]="true"
                       [showPeriodicidadeSemestral]="true"
                       [showPeriodicidadeAnual]="true"   
                       [showPeriodicidadePeriodo]="true"             
                       [(periodicidade)]="filter.periodicidadeVigencia"
                       [(mes)]="filter.mesVigencia"
                       [(trimestre)]="filter.trimestreVigencia"
                       [(semestre)]="filter.semestreVigencia"
                       [(ano)]="filter.anoVigencia"
                       (ngModelChange)="onChangeDataVigencia()"
                       (startDateChange)="onChangeDataInicioVigenciaPeriodo()"
                       (endDateChange)="onChangeDataTerminoVigenciaPeriodo()">
                   </sgt-datepicker> 
                   <div class="input-group-append">
                        <span class="input-group-text">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" [ngModel]="filter.somenteEmUso" (ngModelChange)="onChangeSomenteEmUso($event)" name="filterSomenteEmUso" id="filterSomenteEmUso">
                                <label class="custom-control-label" for="filterSomenteEmUso">Em uso</label>
                            </div>
                        </span>
                   </div>
                </div>
            </div>

            <!-- Status -->
            <div class="campanha-filter-quick-block-options-multiselect-item">
                <sgt-campanha-status-multiselect
                    [(statuses)]="filter.statuses"
                    (statusesChange)="onChangeStatuses()"
                    defaultTitle="Status"
                    [disabled]="!(initialization.initialized | async)">
                </sgt-campanha-status-multiselect>
            </div>

            <!-- Pacotes -->
            <div class="campanha-filter-quick-block-options-multiselect-item">
                <sgt-pacote-campanha-multiselect
                    [(idsPacotes)]="filter.idsPacotes"
                    (idsPacotesChange)="onChangePacotes()"
                    [(somenteAtivos)]="filter.somentePacotesAtivos"
                    defaultTitle="Pacotes"
                    [disabled]="!(initialization.initialized | async)">
                </sgt-pacote-campanha-multiselect>                
            </div>            

            <!-- Representantes -->
            <div class="campanha-filter-quick-block-options-multiselect-item" *ngIf="config?.isShowRepresentantes">
                <sgt-representante-multiselect
                    [(idsRepresentantes)]="filter.idsRepresentantes"
                    (idsRepresentantesChange)="onChangeRepresentantes()"
                    [(somenteAtivos)]="filter.somenteRepresentantesAtivos"
                    defaultTitle="Representantes"
                    [disabled]="!(initialization.initialized | async)">
                </sgt-representante-multiselect>                
            </div>

            <div class="campanha-filter-quick-block-options-filter-psq">
                <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar...">
            </div>        

            <div class="campanha-filter-quick-block-options-btns">
                <div class="campanha-filter-quick-block-options-btns">
                    <div class="btn-group">
                        <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                            [disabled]="!(initialization.initialized | async)">
                            <i class="fas fa-sync"></i>
                        </button>
                        <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                            [disabled]="!(initialization.initialized | async)">
                            <i class="fas fa-eraser" aria-hidden="true"></i>
                        </button>
        
                        
                        <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                            (click)="toggleCollapse()" title="Filtro avançado"
                            [disabled]="!(initialization.initialized | async)">
                            <ng-template [ngIf]="(initialization.initialized | async)">
                                <i class="fas fa-filter" aria-hidden="true"></i>
                                <i [class]="collapseIcon" aria-hidden="true"></i>
                            </ng-template>
                            <ng-template [ngIf]="!(initialization.initialized | async)">
                                <i class='fas fa-spinner fa-pulse'></i>
                            </ng-template>
                        </button>
                       
                    </div>  
                </div>
            </div>
        </div>
    </div>

    
    <div class="campanha-filter-collapse" #filterCollapse>
        <div class="row">
            <div class="form-group col-12 col-md-6 col-xl-3">
                <label for="tiposPromocoes" class="col-form-label">Tipos de Promoções</label>
                <sgt-tipo-promocao-campanha-multiselect
                    [(tipos)]="filter.tiposPromocoes"
                    (tiposChange)="onChangeTiposPromocoes()"
                    [(nullOption)]="filter.tipoPromocaoNull"
                    [showNullOption]="true">
                </sgt-tipo-promocao-campanha-multiselect>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12 col-md-6 col-xl-3">
                <label for="filterGerentes" class="col-form-label">Gerentes</label>
                <sgt-usuario-multi-select
                    id="filterGerentes"
                    name="filterGerentes"
                    [(ngModel)]="filter.idsGerentes"
                    [perfil]="EnumUsuarioPerfil.GERENTE"
                    [situacao]="EnumSituacao.ATIVO"
                    [settings]="{ placeholder: 'Selecione os gerentes', singular: 'Gerente', plural: 'Gerentes', showFooter: false }"
                    (changed)="onChangeGerentes()">
                </sgt-usuario-multi-select>
            </div>
            <div class="form-group col-12 col-md-6 col-xl-3">
                <label for="filterAtendentes" class="col-form-label">Atendentes</label>
                <sgt-usuario-multi-select
                    id="filterAtendentes"
                    name="filterAtendentes"
                    [(ngModel)]="filter.idsAtendentes"
                    [perfil]="EnumUsuarioPerfil.ATENDENTE"
                    [situacao]="EnumSituacao.ATIVO"
                    [settings]="{ placeholder: 'Selecione os atendentes', singular: 'Atendente', plural: 'Atendentes', showFooter: false }"
                    (changed)="onChangeAtendentes()">
                </sgt-usuario-multi-select>
            </div>
        </div>

        <div class="row" *ngIf="config?.isShowCliente">
            <!-- <div class="form-group col-12 col-md">
                <label for="filterClienteVinculado" class="col-form-label">Cliente</label>
                <sgt-typeahead-cliente [(ngModel)]="filter.clienteVinculado" name="filterClienteVinculado" id="filterClienteVinculado"
                    #filterClienteVinculado="ngModel" [ngControl]="filterClienteVinculado"
                    (entitySelected)="onSelectClienteVinculado($event)"
                    (clearEntity)="clearClienteVinculado()">
                </sgt-typeahead-cliente>                                  
                <p class="form-text">Cliente diretamente vinculado à esta campanha</p>
            </div>             -->
            <div class="form-group col-12 col-md">
                <label for="filterClientePromocao" class="col-form-label">Cliente Promoção</label>
                <sgt-typeahead-cliente-pessoa [(ngModel)]="filter.pessoa" name="filterClientePromocao" id="filterClientePromocao"
                    #filterClientePromocao="ngModel" [ngControl]="filterClientePromocao"
                    (entitySelected)="onChangeClientePromocao($event)"
                    (clearEntity)="clearClientePromocao()">
                </sgt-typeahead-cliente-pessoa>  
                <p class="form-text">Cliente em que esta campanha é promovida</p>     
            </div> 
        </div>        
    </div>
</div>

